module.exports = __webpack_public_path__ + "img/collection-weddingRingsPlatinum@2x.bded07c.webp";